// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"modal_wrapper__HKwLy","modal":"modal_modal__hnB7Q","close":"modal_close__x4h4A"};